import React from 'react';
import { Bell } from 'lucide-react';
import { api } from '../../../utils/api';

const NotificationDropdown = ({ notifications, unreadCount, showNotifications, setShowNotifications, onRefresh }) => {
  return (
    <div className="relative">
      <button
        onClick={() => setShowNotifications(!showNotifications)}
        className="relative p-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-700 transition-colors"
        data-testid="notification-bell"
      >
        <Bell className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-red-500 rounded-full text-[10px] font-bold text-white flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {showNotifications && (
        <div className="absolute right-0 top-12 w-80 sm:w-96 bg-slate-800 border border-slate-700 rounded-xl shadow-2xl z-50 max-h-96 overflow-hidden" data-testid="notification-dropdown">
          <div className="flex items-center justify-between p-3 border-b border-slate-700">
            <h3 className="text-sm font-semibold text-white">Notifications</h3>
            {unreadCount > 0 && (
              <button
                onClick={async () => {
                  await api('/notifications/read-all', { method: 'POST' });
                  onRefresh();
                }}
                className="text-xs text-blue-400 hover:text-blue-300"
                data-testid="mark-all-read"
              >
                Mark all read
              </button>
            )}
          </div>
          <div className="overflow-y-auto max-h-72">
            {notifications.length === 0 ? (
              <p className="text-sm text-slate-500 p-4 text-center">No notifications</p>
            ) : (
              notifications.map(n => (
                <div
                  key={n.notification_id}
                  className={`p-3 border-b border-slate-700/50 cursor-pointer hover:bg-slate-700/30 transition-colors ${!n.read ? 'bg-slate-700/20' : ''}`}
                  onClick={async () => {
                    if (!n.read) {
                      await api(`/notifications/${n.notification_id}/read`, { method: 'POST' });
                      onRefresh();
                    }
                  }}
                  data-testid={`notification-${n.notification_id}`}
                >
                  <div className="flex items-start gap-2">
                    <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                      n.severity === 'CRITICAL' ? 'bg-red-500' :
                      n.severity === 'WARNING' ? 'bg-amber-500' : 'bg-blue-500'
                    }`} />
                    <div className="min-w-0">
                      <p className={`text-xs font-medium ${!n.read ? 'text-white' : 'text-slate-400'}`}>{n.title}</p>
                      <p className="text-xs text-slate-500 mt-0.5 line-clamp-2">{n.message}</p>
                      <p className="text-[10px] text-slate-600 mt-1">
                        {new Date(n.created_at).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
